<template>
  <div class="Agenda">
    <form
      id="contact-form"
      class="col-sm-12 scrollimation fade-right"
      v-on:submit.prevent="enviaPergunta"
    >
      <div class="section-header scrollimation fade-up in">
        <h1 class="section-title">Pesquisa de Satisfação</h1>

        <p class="section-description lead">
          Olá {{ pessoa.NOME }},<br />
          Com o intuíto de melhor atendê-lo e para que possamos, sempre, melhorar
          nossos serviços, gostariamos de ouvir a sua opnião.<br />
        </p>
      </div>
      <div v-for="(val, index) in dataSchedule" :key='index'>
        <div>
          <label>Profissional que realizou o atendimento:</label> {{ val.NM_PROFISSIONAL_RECEPCAO }}
        </div>
        <div v-if="val.DS_TIPO_AGENDA == 'Exame'">
          <!-- <label>Exame(s) agendado(s):</label> -->
          <p><label>{{ val.DS_TIPO_AGENDA }} com o(a) Dr(a): </label> {{ val.NM_MEDICO }}</p>
          <p><label>Exame(s): </label> {{ val.DS_ESPEC_OR_PROC }}</p>
          <p><label>Data e hora do(s) Exame(s): </label> {{ val.DT_AGENDAMENTO_STRING }}</p>

        </div>
        <div v-if="val.DS_TIPO_AGENDA == 'Consulta'" class='listProfissional'>
          <p><label>{{ val.DS_TIPO_AGENDA }} com o(a) Dr(a): </label> {{ val.NM_MEDICO }}</p>
          <p><label>Especialidade: </label> {{ val.DS_ESPEC_OR_PROC }}</p>
          <p><label>Data e hora da consulta: </label> {{ val.DT_AGENDAMENTO_STRING }}</p>
        </div>


      </div>
      <h3 class="primary">1. Avalie nossos serviços:</h3>
      <div style="margin-left: 3%">
        <div v-for="(value, key) in perguntas" :key='key'>
          <div v-if="value.TIPO === 'NOTA'">
            <h4 class="primary">{{ value.DS_PERGUNTA }}</h4>
            <div class="controls">
              <div class="form-control">
                <star-rating
                  @rating-selected="setValue($event, value.CD_CODIGO)"
                  v-bind:increment="1"
                  v-bind:max-rating="value.CD_CODIGO === 'Q1' ? 10 : 5"
                  inactive-color="#000"
                  active-color="#21B799"
                  v-bind:star-size="value.CD_CODIGO === 'Q1' ? 25 : 50"
                >
                </star-rating>
              </div>
            </div>
          </div>

          <div v-if="value.TIPO === 'DESCRICAO'">
            <hr />
            <div class="form-group">
              <label class="control-label" for="contact-message">Message</label>
              <h4 class="primary">{{ value.DS_PERGUNTA }}</h4>
              <div class="controls">
                <textarea
                  id="E1"
                  placeholder="Digite aqui..."
                  class="form-control input-lg"
                  rows="3"
                  style="color: black"
                ></textarea>
              </div>
            </div>
            <!-- End textarea -->
          </div>
        </div>
      </div>
      <br /><br /><br />
      <p>
        <input
          type="submit"
          class="btn btn-theme btn-block"
          value="ENVIAR FORMULÁRIO!"
          v-show="bt_envia"
        />
      </p>
      <input type="hidden" name="submitted" id="submitted" value="true" />
    </form>
  </div>
</template>

<script>
import StarRating from "vue-star-rating";
import axios from "axios";
export default {
  components: {
    StarRating,
  },
  name: "Agenda",
  data() {
    return {
      msg: "",
      mostarPerg: true,
      mostarPerg: true,
      bt_envia: true,
      perguntas: [],
      respostas: {},
      pessoa: [],
      dataSchedule: [],
      val: "",
      ind: "",
      error: [],
    };
  },
  mounted() {
    var x = this;

    const dataSplitAgendamento = this.$route.params.nr_sequencia
      .toString()
      .split("-");
    if (dataSplitAgendamento.length == 2) {
      //axios.get(`${this.$api}/carregaPessoaAtendimento/${this.atendimento}`)
      axios
        .get(
          `${this.$api}/carregaDadosAgendamento/${this.$route.params.nr_sequencia}`
        )
        .then((result) => {
          if (!result.status == 200) {
            throw new Erro("Erro desconhecido");
          }

          this.dataSchedule = result.data.dataSshedules;
          this.pessoa.NOME = result.data.dataPacient.name;
          this.perguntas = result.data.dataAsk;
          //this.obterPerguntas(perguntas);
        })
        .catch((err) => {
          console.log("Error desconhecido.");
          this.msg = "Não encontramos o atendimento informado.";
          this.bt_envia = false;
        });
    } else {
      return;
    }
  },
  methods: {
    setValue: function (val, cd) {
      this.$set(this.respostas, cd, val);
    },

    enviaPergunta: function () {
      var x = this;
      var seenvia = false;
      var opn = $("#E1").val();

      if (opn && opn.length > 0) {
        this.setValue(opn, "E1");
      }
      //for(let [index, val] of Object.entries(this.respostas)){
      //  console.log('index', index);
      //  console.log('val', val)
     // }


      for (var val in this.respostas) {
        seenvia = true;
      }

      if (seenvia) {
        let listSchedule = [];
        /* Array(this.dataSchedule).map((val, index) => {

        }) */
        for (const a in this.dataSchedule) {
          this.dataSchedule.map((v) => {
            listSchedule.push({
              NR_SEQUENCIA: v.NR_SEQUENCIA,
              DS_TIPO_AGENDA: v.DS_TIPO_AGENDA,
            });
          });
        }
        const ret = {
          pessoa: this.pessoa.NOME,
          res: this.respostas,
          listSchedule: listSchedule,
        };

        axios({
          method: "POST",
          url: `${this.$api}/api/v2/schedule`,
          data: ret,
          headers: {
            "Content-Type": "application/json",
          },
        })
          .then((val) => {
            if (val.data.status == true) {
              x.bt_envia = false;
              alert("Formulário enviado!");
              location.href = "http://www.samel.com.br/";
            }
          })
          .catch((e) => {
            console.log(e);
            return;
          });
      } else {
        alert("O formulário está em branco, não é possível enviar!");
      }

      return false;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

.list1 ul {
  padding: 0;
}

.list1 li {
  margin: 0 10px;
}

a {
  color: #42b983;
}

.listProfissional p{
  margin: 5px 0 0 0 ;
}

.listProfissional label{
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/agenda.vue